import React from 'react';
import MainCard from 'components/MainCard';
import Typography from '@mui/material/Typography';

export default function Terms() {
  return (
    <MainCard title="Terms & Conditions">
      <Typography variant="body1" color="text.secondary">
        This is a placeholder Terms & Conditions page. Provide your service terms and user obligations here.
      </Typography>
    </MainCard>
  );
}


